import { Mouth } from '../Interfaces/Mouth.interface';
import { Tooth, ToothEruption } from '../../../graphql/graphql';

export const createToothMap = (teeth: Tooth[]): Map<number, Tooth> => {
	const toothMap = new Map<number, Tooth>();
	teeth.forEach(tooth => {
		toothMap.set(tooth.number, tooth);
	});
	return toothMap;
};

export const buildMouth = (toothMap: Map<number, Tooth>): Mouth => {
	const getTooth = (toothNumber: number, babyToothNumber?: number): Tooth => {
		const adultTooth = toothMap.get(toothNumber);

		if (
			!babyToothNumber ||
			(adultTooth && adultTooth.eruption === ToothEruption.Erupted)
		) {
			return adultTooth!;
		}

		return toothMap.get(babyToothNumber)!;
	};

	return {
		upperJaw: {
			L8: getTooth(18),
			L7: getTooth(17),
			L6: getTooth(16),
			L5: getTooth(15, 55),
			L4: getTooth(14, 54),
			L3: getTooth(13, 53),
			L2: getTooth(12, 52),
			L1: getTooth(11, 51),
			R1: getTooth(21, 61),
			R2: getTooth(22, 62),
			R3: getTooth(23, 63),
			R4: getTooth(24, 64),
			R5: getTooth(25, 65),
			R6: getTooth(26),
			R7: getTooth(27),
			R8: getTooth(28),
		},
		lowerJaw: {
			L8: getTooth(48),
			L7: getTooth(47),
			L6: getTooth(46),
			L5: getTooth(45, 85),
			L4: getTooth(44, 84),
			L3: getTooth(43, 83),
			L2: getTooth(42, 82),
			L1: getTooth(41, 81),
			R1: getTooth(31, 71),
			R2: getTooth(32, 72),
			R3: getTooth(33, 73),
			R4: getTooth(34, 74),
			R5: getTooth(35, 75),
			R6: getTooth(36),
			R7: getTooth(37),
			R8: getTooth(38),
		},
	};
};
